import type { BranchConfig, CustomNode } from '@/types/custom-playbooks';

export const APPROVAL_ARMS = [
  { key: 'approved', label: 'Approved' },
  { key: 'rejected', label: 'Rejected' },
] as const;

export const isFork = (node: Pick<CustomNode, 'type'>) =>
  node.type === 'branch' || node.type === 'approval';

/** Fixed approval paths never come from mutable node config. */
export function nodeArms(node: Pick<CustomNode, 'type' | 'config'>) {
  if (node.type === 'approval') return APPROVAL_ARMS;
  if (node.type === 'branch')
    return (node.config as BranchConfig).branches ?? [];
  return [];
}

export function firstNodeArm(node: Pick<CustomNode, 'type' | 'config'>) {
  if (node.type === 'approval') return 'approved';
  if (node.type === 'branch')
    return (node.config as BranchConfig).branches?.find(
      (arm) => arm.conditions !== null
    )?.key;
  return undefined;
}

/** The Else route is separate from the condition branches users configure. */
export function branchRouteSummary(config: BranchConfig): string {
  const arms = config.branches ?? [];
  const branches = arms.filter((arm) => arm.conditions !== null).length;
  const hasElse = arms.some((arm) => arm.conditions === null);
  if (!branches) return hasElse ? 'Else only' : 'No branches';
  return `${branches} branch${branches === 1 ? '' : 'es'}${hasElse ? ' + Else' : ''}`;
}
